import { useQuery } from '@tanstack/react-query';
import { fetchDocumentTemplate } from '../services/documentTemplates';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useDocumentTemplateQuery = (id: string | undefined) =>
  useQuery({
    queryKey: documentTemplateKeys.detail(id ?? ''),
    queryFn: () => fetchDocumentTemplate(id as string),
    enabled: Boolean(id),
  });
